// Third party
import React from 'react';

// Utils
import { formatMessage } from '@/utils/i18n';
import FormattedMessage from '@/utils/i18n/FormattedMessage';
import { Typography } from '@capintel/component-lib/typography';
import { ALLOWED_HTML_TAGS } from '@/views/components/i18n/FormattedMessageV2';

type SearchHeaderProps = {
  inputValue: string;
  filterQuery: string;
  handleFilterChange: (value: string) => void;
  setFilterQuery: (value: string) => void;
  setInputValue: (value: string) => void;
};

export const SearchHeader = ({ inputValue, filterQuery, handleFilterChange, setFilterQuery, setInputValue }: SearchHeaderProps) => (
  <header className="py-2 px-3">
    <div className="d-flex justify-content-between p-1 mb-2">
      <Typography as={ALLOWED_HTML_TAGS.H2} variant="headerXs">
        <FormattedMessage id="Proposal.AddContent" />
      </Typography>
    </div>
    <div className="filter-search-box">
      <i className="icon-search" />
      <input
        placeholder={formatMessage('Common.Filter')}
        className="w-100"
        type="search"
        onChange={(e: any) => handleFilterChange(e.target.value)}
        value={inputValue}
      />
      {filterQuery.length > 0 && (
        <button
          onClick={() => {
            setFilterQuery('');
            setInputValue('');
          }}
        >
          <i className="icon-cross-thin" />
          <span className="visually-hidden">Clear</span>
        </button>
      )}
    </div>
  </header>
);

export default SearchHeader;
